/**
 * Shared column header sizing for data grids.
 * Uses min-width from title length so headers stay on one line; table scrolls horizontally.
 */
export function getColumnHeaderMinWidth(column) {
  if (column?.headerMinWidth) return column.headerMinWidth;
  if (column?.minWidth) return column.minWidth;
  const title = column?.title || '';
  const len = title.length;
  if (len <= 6) return 72;
  if (len <= 10) return 96;
  if (len <= 14) return 112;
  if (len <= 18) return 128;
  if (len <= 24) return 144;
  return 160;
}

export function columnHeaderStyle(column) {
  return { minWidth: `${getColumnHeaderMinWidth(column)}px` };
}

/** Prefer min-width utility over narrow % widths on headers. */
export function columnHeaderWidthClass(column) {
  if (column?.minWidthClass) return column.minWidthClass;
  if (column?.headerClassName?.includes('min-w-')) return '';
  return '';
}
